export default {
  AR_INVOICE: 93,
  W9: 6,
  ACH: 86,
  DIVISION_ORDER: 87,
  RUN_STATEMENT: 89,
  DOCUMENT_1099: 90,
  OWNER_STATEMENT: 91,
  PENDING_DIVISION_ORDER: 94,
  SUSPENSE_REPORT: 95,
  DIVISION_OF_INTEREST_REPORT: 96,
  REVENUE_DISTRIBUTION_BY_PROPERTY_REPORT: 97,
  SUMMARY_BY_DISTRIBUTION_REPORT: 98,
  OPERATOR_EXPENSE_REPORT: 99,
  OUTSIDE_OPERATOR_EXPENSE_REPORT: 100,
};
